import gql from "graphql-tag";

export default gql`
  query ShipmentRequest {
    waitingShipmentRequest {
      id,
      cementType,
      cep,
      code,
      constructionAddress,
      constructionName,
      contractCode,
      driver {
        cpf
        name
        phoneNumber
        licenseNumber
        licenseExpirationDate
      },
      equipmentCode,
      equipmentPlate,
      fck,
      formulaCode,
      gravelType,
      loadingStationCode,
      materials {
        materialCode,
        humidity,
        supplier,
        order,
        weight,
        locations {
          locationCode,
          weight,
          materialCode,
        },
      },
      operatorName,
      proofBody,
      quantity,
      sealNumber,
      slump,
      status,
      statusMessage,
      waterCut,
    }
  }
`;
